"use client";

import styles from "./RouteLoading.module.scss";

type RouteLoadingProps = {
  /** Use full viewport height (for root-level loading) */
  fullHeight?: boolean;
};

const BLOCK_ROWS = 3;
const BLOCK_COLS = 4;

/**
 * Custom route loading component with a data-portal-themed block construction
 * animation. Blocks join together suggesting data assembly. Uses Carbon theme
 * variables for light (white) and dark (g90) themes.
 */
export default function RouteLoading({ fullHeight = false }: RouteLoadingProps) {
  return (
    <div
      className={`${styles.routeLoading} ${fullHeight ? styles["routeLoading--full"] : ""}`}
      role="status"
      aria-live="polite"
      aria-label="Loading"
    >
      <div className={styles.routeLoading__content}>
        <div className={styles.routeLoading__blocksGrid} aria-hidden>
          {Array.from({ length: BLOCK_ROWS * BLOCK_COLS }).map((_, i) => (
            <div
              key={i}
              className={styles.routeLoading__block}
              style={{ animationDelay: `${i * 80}ms` }}
            />
          ))}
        </div>
        <span className={styles.routeLoading__text}>Loading...</span>
      </div>
    </div>
  );
}
